<template>
  <div class="mt">
    <!-- {{ sCrtType }} -->
    <van-grid column-num="1" clickable :border="false">
      <van-grid-item @click="cmdMT(obj)">
        <div v-if="isSelected(obj)" class="selected">{{ obj.id }}</div>
        <div v-else class="unselect">{{ obj.id }}</div>
      </van-grid-item>
    </van-grid>
    <!-- <div @click="cmdMT(obj)">
      <div v-if="isSelected(obj)" class="mt selected">{{ obj.id }}</div>
      <div v-else class="mt unselect">{{ obj.id }}</div>
    </div> -->
  </div>
</template>

<style scoped>
.van-image {
  width: 6rem;
  height: 6rem;
  border-radius: 3rem;
}
.mt {
  margin: auto;
  background-size: 110px;
  height: 5rem;
  line-height: 2.2rem;
  background-repeat: no-repeat;
  background-position-x: 5px;
  text-align: center;
}
.selected {
  border-bottom: 0.15rem grey solid;
  padding-bottom: 5px;
  border-color: v-bind(sGetConfig("color3"));
  color: v-bind(sGetConfig("color3"));
}
.unselect {
  border-bottom: 0.15rem white solid;
  padding-bottom: 5px;
}
/* .selected {
  background-image: url(../../../assets/mt1.png);
  color: white;
}
.unselect {
  background-image: url(../../../assets/mt0.png);
  color: rgb(136, 99, 99);
} */

/* background-image: url(../../assets/cloud.png); */
</style>

<script>
export default {
  components: {},
  props: {
    obj: Object,
  },
  data() {
    return {};
  },
  methods: {
    getItemQty(item) {
      var array = this.ordertmp.filter(
        (r) => r.TypeNo == item.TypeNo && r.ItemName == item.ItemName
      );
      return this.gSum(array, "Qty");
    },
    cmdMI(obj) {
      this.$emit("click", obj);
    },
    cmdMT(obj) {
      this.gSetCrtType(obj);
      // mt = menutype[0];

      // this.$store.commit("setCrtType", mt);
      // this.$store.commit("setCrtType", obj);
      this.$emit("click", obj);
    },
    isSelected(obj) {
      // var menutype = this.sBKMenu.menutype;
      // // console.log(obj.id);
      // // console.log(menutype);
      // var find = menutype.find((r) => r.id == obj.id);
      // console.log("find",find);
      if (obj.id == this.sCrtType.id) {
        return true;
      }
      return false;
    },
  },
};
</script>
